import ErrorMessage from '@kopapro/components/commons/errorMessage/errorMessage';

export default ErrorMessage;
